import React, { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import { useSelector } from "react-redux";

import { axiosInstance } from "../../Axios";
import { utc_to_eet } from "../../utilities/formatters";

const BalanceCurve = ({ login_id }) => {
  const [PerformanceChart, setPerformanceChart] = useState(false);

  const ACCtoken = useSelector((state) => state.ACCtoken);
  const GetPerformanceChartV2 = (login_id) => {
    if (login_id) {
      axiosInstance
        .post(`/performance-chart/v2/${login_id}/`, {
          idToken: ACCtoken,
        })
        .then((res) => {
          setPerformanceChart(res.data);
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    if (login_id) GetPerformanceChartV2(login_id);
  }, [login_id]);

  const [Series, setSeries] = useState([
    {
      name: "Balance",
      type: "area",
      data: [],
    },
  ]);
  const [Options, setOptions] = useState({
    colors: ["#04D9FF"],
    fill: {
      colors: "#04D9FF",
      type: "gradient",
      gradient: {
        type: "vertical",
        shadeIntensity: 0,
        gradientToColors: undefined,
        opacityFrom: 0.7,
        opacityTo: 0.2,
        stops: [0, 90, 100],
      },
    },
    legend: {
      fontSize: "14px",
      fontWeight: 700,
      labels: {
        colors: "white",
      },
      markers: {
        width: 15,
        height: 15,
      },
    },
    chart: {
      fontFamily: "Outfit, sans-serif",
      toolbar: {
        show: false,
      },
      height: 350,
      type: "area",
      zoom: {
        enabled: false,
      },
      animations: {
        enabled: false,
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      curve: "smooth",
      width: 4,
    },
    grid: {
      borderColor: "#415672",
      strokeDashArray: 8,
    },
    labels: [],
    xaxis: {
      type: "datetime",
      tooltip: {
        enabled: false,
      },
      axisTicks: {
        show: false,
      },
      axisBorder: {
        show: false,
      },
      labels: {
        style: {
          colors: "#8B8E93",
          fontSize: "12px",
        },
      },
    },
    yaxis: [
      {
        type: "numeric",
        labels: {
          style: {
            colors: "#8B8E93",
            fontSize: "12px",
          },
        },
      },
    ],
    tooltip: {
      enabled: true,
      style: {
        fontSize: "14px",
        fontWeight: "700",
      },
      x: {
        show: true,
        formatter: (val) => {
          const date = new Date(val);
          return `${date.toDateString()} ${date.toLocaleTimeString()}`;
        },
      },
    },
  });

  useEffect(() => {
    if (PerformanceChart) {
      const balance_arr = (PerformanceChart && PerformanceChart.balance) || [];
      const date_arr =
        (PerformanceChart &&
          PerformanceChart.date.map((date_str) => utc_to_eet(date_str))) ||
        [];

      setOptions({
        ...Options,
        labels: date_arr,
        // xaxis: {
        //   ...Options.xaxis,
        //   categories: date_arr,
        // },
      });

      setSeries([
        {
          name: "Balance",
          type: "area",
          data: balance_arr,
        },
      ]);
    }
  }, [PerformanceChart]);

  return (
    <div id="chart">
      <ReactApexChart options={Options} series={Series} />
    </div>
  );
};
export default BalanceCurve;
